import(/* webpackMode: "eager" */ "/workspace/node_modules/@next/third-parties/dist/google/ga.js");
;
import(/* webpackMode: "eager" */ "/workspace/node_modules/@next/third-parties/dist/google/gtm.js");
;
import(/* webpackMode: "eager" */ "/workspace/node_modules/@next/third-parties/dist/ThirdPartyScriptEmbed.js");
;
import(/* webpackMode: "eager" */ "/workspace/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager", webpackExports: ["Footer"] */ "/workspace/src/components/footer/footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Header"] */ "/workspace/src/components/header/header.tsx");
;
import(/* webpackMode: "eager" */ "/workspace/src/styles/globals.css");
